import { AnimationDetailsDTO } from "../../../dto/AnimationDetailsDTO";
import { AnimationDTO } from "../../../dto/AnimationDTO";

/**
 * Shown when a content reference's `animationId` is unknown to the API (404):
 * the state was renamed or removed in Unity, or the content's state string
 * differs in case or whitespace from what was registered.
 */
export const ANIMATION_UNAVAILABLE_LABEL = "Animation unavailable";

export function getAnimationDisplayLabel(
  animation: Pick<AnimationDTO, "name" | "animationState"> | undefined | null
) {
  if (!animation) return "No animation selected";
  return animation.animationState || animation.name;
}

export function getAnimationStoredName(
  animation: Pick<AnimationDetailsDTO, "name"> | undefined | null
) {
  return animation?.name ?? "";
}
